import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DetectPlatformService } from '../../services/detectPlatform.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'landing-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class LandingHeaderComponent {
  @Input() isLoggedIn;
  @Input() navOpened;
  @Output() toggleNav = new EventEmitter();
  @Output() onLinkClicked = new EventEmitter();
  androidLink = environment.androidAppLink;
  iOSLink = environment.iOSAppLink;

  constructor(public detectPlatformService: DetectPlatformService) {}
}
